import { Center, Flex } from "@chakra-ui/react";
import TalesSpinnerBig from "../../atoms/TalesSpinner/big";
import React from "react";

export default function Loading() {
  return (
    <Flex
      width={"100vw"}
      height={"100vh"}
      alignContent={"center"}
      justifyContent={"center"}
    >
      <Center>
        <TalesSpinnerBig />
      </Center>
    </Flex>
  );
}
